import { Injectable } from "@angular/core";
import { Http, Response, URLSearchParams } from "@angular/http";
import { Angular2TokenService } from 'angular2-token';
import { Booking } from "@models/booking";
import { Observable } from "rxjs/Observable";
import { TutorTimeslots } from "@models/tutor-timeslots";
import { Contact } from "@models/contact";

export interface DeleteBookingParams {
  booking: Booking
  ban: boolean
}

export interface AffectedBookingsParams {
  startDateTime: Date,
  endDateTime: Date,
  tutorAllocationId: number
}

export interface BookingPotentialStudentsParams {
  windowId: number,
  date: Date,
  period: number
}

export interface TimeslotsParams {
  windowId: number,
  twoWeekBlockIndex: number
}

@Injectable()
export class BookingService {

  private bookingsUrl: string = 'bookings';

  constructor(
    private http: Angular2TokenService,
  ) {}

  create(b: Booking) {
    return this.http.post(this.bookingsUrl, b.serializeForRails())
      .map((res: Response) => Booking.clone(res.json()))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  update(b: Booking) {
    return this.http.put(`${this.bookingsUrl}/${b.id}`, b.serializeForRails())
      .map((res: Response) => Booking.clone(res.json()))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  timeslots(params: TimeslotsParams): Observable<TutorTimeslots[]> {
    const url = `${this.bookingsUrl}/timeslots/${params.twoWeekBlockIndex}/${params.windowId}`
    return this.http.get(url)
      .map((res: Response) => res.json().map((t: any) => TutorTimeslots.clone(t)))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  potentialStudents(params: BookingPotentialStudentsParams): Observable<Contact[]> {
    const search: URLSearchParams = new URLSearchParams()
    for (let key in params) { search.set(key, params[key]); }

    return this.http.get(`${this.bookingsUrl}/potential_students`, { search })
      .map((res: Response) => res.json().map((c: any) => Contact.clone(c)))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  affectedBookings(params: AffectedBookingsParams): Observable<Booking[]> {
    return this.http.put(`${this.bookingsUrl}/affected_bookings`, params)
      .map((res: Response) => res.json().map((b: any) => Booking.clone(b)))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  remove(params: DeleteBookingParams): Observable<any> {
    const searchParams: URLSearchParams = new URLSearchParams()
    const options: any = { search: searchParams }

    searchParams.set("ban", params.ban.toString())

    return this.http.delete(`${this.bookingsUrl}/${params.booking.id}`, options)
      .catch((error: Response) => Observable.throw(error.json()))
  }

  sameDayCancel(bookingId: number): Observable<Booking> {
    return this.http.put(`${this.bookingsUrl}/${bookingId}/same_day_cancel`, {})
      .map((res: Response) => Booking.clone(res.json()))
      .catch((error: Response) => Observable.throw(error.json()))
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/services/booking.ts